<div class="button-plain">
  <markant-icon
    *ngIf="!!iconName"
    class="icon"
    [icon]="iconName"
  ></markant-icon>
  <span>{{ text }}</span>
</div>
